module.exports = __webpack_public_path__ + "icon-close.png?71a9983be01135673d66d5d589a69c9f";


//////////////////
// WEBPACK FOOTER
// ./img/landing_v2/icon-close.png
// module id = 377
// module chunks = 0